__turbopack_context__.v({
  "button": "_-wPCq_button",
  "loader": "_-wPCq_loader",
});
